import { dateFormat } from "../../Helpers/format";

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("mouseup", function (e) {
    var roomsOptions = document.querySelector(".js-rooms-options");
    if (
      roomsOptions &&
      !roomsOptions.contains(e.target) &&
      !roomsOptions.matches(e.target)
    ) {
      if (window.innerWidth > 767) {
        roomsOptions.classList.remove("hotel-booking__rooms-options--open");
      }
    }
  });

  hotelDatePicker();
});

document.body.addEventListener("click", function (e) {
  var target = e.target;
  if (target.classList.contains("js-close-auto-complete")) {
    var focused = document.querySelector(".focused");
    if (focused) {
      focused.classList.remove("focused");
    }
    document.querySelector(".js-mobile-layout").style.display = "block";
    document.querySelector("#js-hotel-city").hotelautoComplete("close");
    document.querySelector("html").classList.remove("no-scroll");
    document.querySelector(".js-search-input").classList.remove("show-mobile");
  }
});

var hotelList = [];

var internalHotelList = window.internalHotelList;

var externalHotelList = window.externalHotelList;

function getDate(dateType, localeType = "fa") {
  if (!window.searchInitialize?.search) return "";

  let locale = localeType;

  let format = "jYYYY/jMM/jDD";

  if (locale === "en-us") {
    format = "YYYY-MM-DD";
  }

  if (window.searchInitialize?.search) {
    if (dateType === "checkIn") {
      if (window.searchInitialize?.search?.checkIn == null) return "";

      return dateFormat(
        window.searchInitialize?.search?.checkIn,
        locale,
        format
      );
    } else if (dateType === "checkOut") {
      if (window.searchInitialize?.search?.checkOut == null) return "";

      return dateFormat(
        window.searchInitialize?.search?.checkOut,
        locale,
        format
      );
    }
  }
}

window.hotelDataModel = {
  hotelTitle: window.searchInitialize?.search?.destinations?.title,

  cityTitle: "",

  citySlug: window.searchInitialize?.search?.destinations?.citySlug || "",

  slug: window.searchInitialize?.search?.destinations?.slug || "",

  countryTitle: "",

  countrySlug: window.searchInitialize?.search?.destinations?.countrySlug || "",

  id: window.searchInitialize?.search?.destinations?.id || "",

  hotelEndDate: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkOut"),

  hotelEndDateEn: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkOut", "en-us"),

  hotelStartDate: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkIn"),

  hotelStartDateEn: window.searchInitialize?.search?.isStaticPage
    ? ""
    : getDate("checkIn", "en-us"),

  locationType: window.searchInitialize?.search?.destinations.locationType || 1,

  destinationType:
    window.searchInitialize?.search?.destinations.destinationType,

  daysDuration: null,

  roomsCount: 1,

  childLabels: [],

  dir: "rtl",

  childsCount: 0,

  adultsCount: 0,

  rooms: [
    {
      room: 1,
      adult: 2,
      child: 0,
      childs: [],
    },
  ],

  sort: null,

  filter: null,
};

// AutoComplete
function hotelSearch() {
  var bookingSections = document.querySelectorAll(".js-booking-section.active");
  bookingSections.forEach(function (section) {
    if (section.getAttribute("data-searchType") === "internal-hotel") {
      if (typeof internalHotelList !== "undefined") {
        hotelList = internalHotelList;
      }
    } else {
      if (typeof externalHotelList !== "undefined") {
        hotelList = externalHotelList;
      }
    }

    var hotelCityInput = section.querySelector(".js-hotel-form #js-hotel-city");
    hotelAutoSearch(hotelCityInput, 2);
  });
}

function hotelAutoSearch(input, destinationType) {
  input.addEventListener("input", function () {
    var searchTerm = input.value.trim();
    var searchLoading =
      input.nextElementSibling.querySelector(".js-search-loading");
    if (searchTerm && hotelList !== null) {
      searchLoading.style.display = "block";
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "/hotelbooking-api/searchtitle/" +
          searchTerm +
          "/?destinationtype=" +
          destinationType +
          "&demandtype=0"
      );
      xhr.onload = function () {
        if (xhr.status === 200) {
          var data = JSON.parse(xhr.responseText).model;
          var results = data.map(function (obj) {
            return {
              value: obj.title,
              hotelTitle: obj.title,
              slug: obj.slug,
              cityTitle: obj.cityTitle,
              citySlug: obj.citySlug,
              countrySlug: obj.countrySlug,
              countryTitle: obj.countryTitle,
              locationType: obj.locationType,
              destinationType: obj.destinationType,
              id: obj.id,
              isRtl: obj.isRtl,
              dir: obj.dir,
            };
          });
          searchLoading.style.display = "none";
          input.hotelautoComplete("close");
          input.hotelautoComplete("search", results);
        }
      };
      xhr.onerror = function () {
        searchLoading.style.display = "none";
      };
      xhr.send();
    } else {
      input.hotelautoComplete("search", hotelList);
    }
  });
}

document.body.addEventListener("click", function (e) {
  var roomsOptions = document.querySelector(".js-rooms-options");
  if (
    roomsOptions &&
    !roomsOptions.contains(e.target) &&
    !roomsOptions.matches(e.target)
  ) {
    roomsOptions.classList.remove("hotel-booking__rooms-options--open");
  }
});

function hotelDatePicker() {
  var datePickerInputs = document.querySelectorAll(".js-datepicker-input");
  datePickerInputs.forEach(function (input) {
    var dateFormat = input.getAttribute("data-date-format");
    var minDate = input.getAttribute("data-min-date");
    var maxDate = input.getAttribute("data-max-date");
    var initialDate = input.getAttribute("data-initial-date");
    var datepicker;
    if (dateFormat) {
      datepicker = new hotelDatePicker(input, {
        format: dateFormat,
        minDate: minDate || null,
        maxDate: maxDate || null,
        autoClose: true,
        onSelect: function (formattedDate, date, inst) {
          var inputField = inst.el;
          var targetId = inputField.getAttribute("data-target");
          if (targetId) {
            var targetInput = document.getElementById(targetId);
            if (targetInput) {
              targetInput.value = formattedDate;
              targetInput.focus();
              var event = new Event("input", {
                bubbles: true,
                cancelable: true,
              });
              targetInput.dispatchEvent(event);
            }
          }
        },
      });
    }

    if (initialDate && datepicker) {
      datepicker.setDate(initialDate);
    }
  });
}

function updatePrice() {
  var roomOptions = document.querySelector(".js-rooms-options");

  if (roomOptions) {
    var roomType = roomOptions.getAttribute("data-room-type");
    var selectedRoom = roomOptions.querySelector(
      '.js-room-option[data-room-type="' + roomType + '"]:checked'
    );
    var price = selectedRoom.getAttribute("data-price");
  }

  var totalPriceContainer = document.querySelector(".js-total-price");

  if (totalPriceContainer) {
    totalPriceContainer.textContent = price;
  }
}

function updateRoomOptions(roomType) {
  var roomOptions = document.querySelector(".js-rooms-options");

  if (roomOptions) {
    var roomTypeContainers = roomOptions.querySelectorAll(".js-room-option");

    roomTypeContainers.forEach(function (container) {
      if (container.getAttribute("data-room-type") === roomType) {
        container.style.display = "block";
      } else {
        container.style.display = "none";
      }
    });
  }
}

function toggleRoomOptions() {
  var roomOptions = document.querySelector(".js-rooms-options");
  if (roomOptions) {
    roomOptions.classList.toggle("hotel-booking__rooms-options--open");
  }
}

function updateDatePickerMode(mode) {
  localStorage.setItem("datePickerMode", mode);

  var dateInputs = document.querySelectorAll(".js-datepicker-input");

  if (dateInputs) {
    dateInputs.forEach(function (input) {
      var datepickerInstance = input.data("datepicker");
      if (datepickerInstance) {
        datepickerInstance.setOptions({ mode: mode });
      }
    });
  }
}

function initMobileBooking() {
  var mobileLayout = document.querySelector(".js-mobile-layout");
  var searchInput = document.querySelector(".js-search-input");
  var searchButton = document.querySelector(".js-search-button");
  var datePicker = document.querySelector(".js-mobile-datepicker");

  if (mobileLayout && searchInput && searchButton && datePicker) {
    searchInput.addEventListener("click", function () {
      mobileLayout.style.display = "none";
      document.body.classList.add("no-scroll");
      searchInput.classList.add("show-mobile");
      setTimeout(function () {
        searchInput.focus();
      }, 300);
    });

    searchButton.addEventListener("click", function () {
      mobileLayout.style.display = "none";
      document.body.classList.add("no-scroll");
      searchInput.classList.add("show-mobile");
      setTimeout(function () {
        searchInput.focus();
      }, 300);
    });

    datePicker.addEventListener("click", function () {
      mobileLayout.style.display = "none";
      document.body.classList.add("no-scroll");
      searchInput.classList.add("show-mobile");
      setTimeout(function () {
        searchInput.focus();
      }, 300);
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  hotelSearch();
  updatePrice();

  var roomTypeSelector = document.querySelector(".js-room-type-selector");

  if (roomTypeSelector) {
    roomTypeSelector.addEventListener("change", function () {
      var selectedRoomType = roomTypeSelector.value;
      updateRoomOptions(selectedRoomType);
      updatePrice();
    });
  }

  var datePickerModeSelector = document.querySelector(
    ".js-date-picker-mode-selector"
  );

  if (datePickerModeSelector) {
    datePickerModeSelector.addEventListener("change", function () {
      var selectedMode = datePickerModeSelector.value;
      updateDatePickerMode(selectedMode);
    });
  }

  var toggleRoomOptionsButton = document.querySelector(
    ".js-toggle-room-options"
  );

  if (toggleRoomOptionsButton) {
    toggleRoomOptionsButton.addEventListener("click", function () {
      toggleRoomOptions();
    });
  }

  var roomOptions = document.querySelector(".js-rooms-options");

  if (roomOptions) {
    roomOptions.addEventListener("change", function () {
      updatePrice();
    });
  }

  initMobileBooking();
});
